import { equals } from 'ramda'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { redirect } from 'redux-first-router'
import { useDebouncedCallback } from 'use-debounce/lib'

import { updateSearchFilterAction } from '~shared-components/filters/filter.actions'
import {
  updateSearchInputAction,
  updateSearchQueryAction,
} from '~shared-components/redux/actions/search.actions'
import { LocationSelector } from '~shared-components/redux/selectors/location.selector'
import { SearchSelector } from '~shared-components/redux/selectors/search.selector'

export const useSearchQuery = (minChars = 1) => {
  const dispatch = useDispatch()
  const query = useSelector(SearchSelector.query)
  const input = useSelector(SearchSelector.input)
  const { payload, query: search, type } = useSelector(
    LocationSelector.location,
    equals,
  )

  const updateLocationSearchQueryAction = (searchQuery?: string) =>
    redirect({
      payload,
      query: { ...search, searchQuery },
      type,
    })

  const {
    updateLocationSearchQuery,
    updateSearchFilter,
    updateSearchInput,
    updateSearchQuery,
  } = bindActionCreators(
    {
      updateLocationSearchQuery: updateLocationSearchQueryAction,
      updateSearchFilter: updateSearchFilterAction,
      updateSearchInput: updateSearchInputAction,
      updateSearchQuery: updateSearchQueryAction,
    },
    dispatch,
  )

  const {
    callback: debouncedonSearchQueryChange,
    flush,
  } = useDebouncedCallback((value: string | undefined) => {
    updateSearchQuery(value)
    updateSearchFilter(value)
    updateLocationSearchQuery(value)
  }, 300)

  const onSearchQueryChange = useCallback(
    (value: string) => {
      updateSearchInput(value)
      debouncedonSearchQueryChange(value.length >= minChars ? value : undefined)
      if (value === '') flush()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [minChars],
  )

  return {
    input,
    onSearchQueryChange,
    query,
  }
}
